<div class="container-fluid merchant-payment-page" *ngIf="userType === 100 && merchantId; else notMerchant">

  <!-- Full-page card registration (same tab, replaces list while open) -->
  <ng-container *ngIf="showCardRegistrationPanel">
    <div class="merchant-payment-header d-flex align-items-start gap-3 mb-4 flex-wrap">
      <button
        type="button"
        class="mp-btn-back"
        (click)="exitCardRegistration()"
        [attr.aria-label]="
          curentLang === 'en'
            ? 'Back to payment cards'
            : curentLang === 'ar'
              ? 'العودة إلى بطاقات الدفع'
              : 'חזרה לכרטיסי התשלום'"
      >
        <i class="fa fa-arrow-left" aria-hidden="true"></i>
      </button>
      <div class="merchant-payment-header__titles">
        <h1 class="merchant-payment-header__title mb-1">
          {{
            curentLang === 'en'
              ? 'Secure Card Registration'
              : curentLang === 'ar'
                ? 'تسجيل كارت آمن'
                : 'רישום כרטיס מאובטח'
          }}
        </h1>
        <p class="merchant-payment-header__subtitle mb-0">
          {{
            curentLang === 'en'
              ? 'Complete registration on the PayPlus page below. Your card will be saved when you finish.'
              : curentLang === 'ar'
                ? 'أكمل التسجيل في صفحة PayPlus أدناه. سيُحفظ الكارت عند الانتهاء.'
                : 'השלם את הרישום בדף PayPlus למטה. הכרטיס יישמר בסיום.'
          }}
        </p>
      </div>
    </div>
    <div class="card shadow-sm section-card mb-4">
      <div class="card-body p-0 section-card__body">
        <div class="payment-iframe-info alert alert-info m-3 mb-0 small d-flex align-items-center gap-2">
          <i class="fa fa-shield fa-lg"></i>
          {{
            curentLang === 'en'
              ? 'Enter your card details on the secure PayPlus page.'
              : curentLang === 'ar'
                ? 'أدخل بيانات الكارت في صفحة PayPlus الآمنة.'
                : 'הזן את פרטי הכרטיס בדף PayPlus המאובטח.'
          }}
        </div>
        <iframe
          *ngIf="paymentUrl"
          [src]="paymentUrl"
          class="payment-iframe"
          frameborder="0"
          allow="payment"
        ></iframe>
      </div>
    </div>
  </ng-container>

  <ng-container *ngIf="!showCardRegistrationPanel">
  <div class="merchant-payment-header d-flex align-items-start gap-3 mb-4 flex-wrap">
    <button
      type="button"
      class="mp-btn-back"
      (click)="goBack()"
      [attr.aria-label]="
        curentLang === 'en'
          ? 'Back to dashboard'
          : curentLang === 'ar'
            ? 'العودة إلى لوحة التحكم'
            : 'חזרה ללוח הבקרה'"
    >
      <i class="fa fa-arrow-left" aria-hidden="true"></i>
    </button>
    <div class="merchant-payment-header__titles">
      <h1 class="merchant-payment-header__title mb-1">
        {{
          curentLang === 'en'
            ? 'Payment cards'
            : curentLang === 'ar'
              ? 'بطاقات الدفع'
              : 'כרטיסי תשלום'
        }}
      </h1>
      <p class="merchant-payment-header__subtitle mb-0">
        {{
          curentLang === 'en'
            ? 'Register and manage cards saved on your merchant account.'
            : curentLang === 'ar'
              ? 'سجّل وأدر البطاقات المحفوظة لحساب التاجر.'
              : 'רישום וניהול כרטיסים השמורים בחשבון הסוחר.'
        }}
      </p>
    </div>
  </div>

  <!-- ─── قسم الكروت ─── -->
  <div class="row mb-4">
    <div class="col-12">
      <div class="card shadow-sm section-card">
        <div class="card-header section-card__header d-flex justify-content-between align-items-center flex-wrap gap-2">
          <div>
            <h5 class="mb-1 section-title">
              <i class="fa fa-credit-card me-2"></i>
              {{ curentLang === 'en' ? 'Saved Payment Cards' : (curentLang === 'ar' ? 'بطاقات الدفع المحفوظة' : 'כרטיסי תשלום שמורים') }}
            </h5>
            <p class="section-subtitle mb-0">
              {{ curentLang === 'en' ? 'Manage registered cards and their activation status.' : (curentLang === 'ar' ? 'إدارة الكروت المسجلة وحالة التفعيل.' : 'ניהול כרטיסים רשומים ומצב הפעלה.') }}
            </p>
          </div>
          <button type="button" class="btn btn-sm mp-add-card-btn" (click)="registerCard()">
            <i class="fa fa-plus me-1"></i>
            {{ curentLang === 'en' ? 'Add new card' : (curentLang === 'ar' ? 'إضافة كارت جديد' : 'הוסף כרטיס חדש') }}
          </button>
        </div>

        <div class="card-body section-card__body">

          <!-- Loading -->
          <div *ngIf="loadingCards" class="text-center py-4">
            <span class="spinner-border spinner-border-sm" role="status"></span>
            <span class="ms-2 text-muted small">
              {{ curentLang === 'en' ? 'Loading cards...' : (curentLang === 'ar' ? 'جاري تحميل الكروت...' : 'טוען כרטיסים...') }}
            </span>
          </div>

          <!-- Empty -->
          <div *ngIf="!loadingCards && !cards.length" class="alert alert-light border text-center empty-state">
            <i class="fa fa-credit-card fa-2x mb-2 d-block text-muted"></i>
            {{ curentLang === 'en' ? 'No saved cards yet.' : (curentLang === 'ar' ? 'لا توجد كروت محفوظة حالياً.' : 'אין כרטיסים שמורים עדיין.') }}
          </div>

          <!-- Cards grid -->
          <div class="row g-3" *ngIf="!loadingCards && cards.length">
            <div class="col-12 col-sm-6 col-xl-4" *ngFor="let card of cards">

              <!-- Visual credit card -->
              <div class="credit-card-visual" dir="ltr" [style.background]="cardGradient(card.brandId, card.cardBin)">
                <div class="credit-card-visual__top">
                  <div class="credit-card-visual__chip">
                    <i class="fa fa-microchip"></i>
                  </div>
                  <span class="credit-card-visual__brand d-flex flex-column align-items-end">
                    <i class="fa {{ brandIcon(card.brandId, card.cardBin) }} fa-2x"></i>
                    <span class="credit-card-visual__brand-name">{{ brandName(card.brandId, card.cardBin) }}</span>
                  </span>
                </div>
                <div class="credit-card-visual__number" dir="ltr">
                  {{ card.cardBin }} &bull;&bull;&bull;&bull;&bull;&bull; {{ card.cardLast4 }}
                </div>
                <div class="credit-card-visual__bottom">
                  <div>
                    <div class="credit-card-visual__label">
                      {{ curentLang === 'en' ? 'Card Holder' : (curentLang === 'ar' ? 'حامل الكارت' : 'בעל הכרטיס') }}
                    </div>
                    <div class="credit-card-visual__value">{{ card.cardHolderName || '—' }}</div>
                  </div>
                  <div class="text-end">
                    <div class="credit-card-visual__label">
                      {{ curentLang === 'en' ? 'Expires' : (curentLang === 'ar' ? 'الصلاحية' : 'תוקף') }}
                    </div>
                    <div class="credit-card-visual__value">{{ card.expiryMonth }}/{{ card.expiryYear }}</div>
                  </div>
                </div>
              </div>

              <!-- Card actions row -->
              <div class="d-flex align-items-center justify-content-between mt-2 px-1">
                <span class="badge rounded-pill px-3 py-2"
                      [class.bg-success]="card.isActive"
                      [class.bg-secondary]="!card.isActive">
                  <i class="fa me-1" [class.fa-check-circle]="card.isActive" [class.fa-times-circle]="!card.isActive"></i>
                  {{ card.isActive
                    ? (curentLang === 'en' ? 'Active' : (curentLang === 'ar' ? 'نشط' : 'פעיל'))
                    : (curentLang === 'en' ? 'Inactive' : (curentLang === 'ar' ? 'معطّل' : 'לא פעיל')) }}
                </span>
                <div class="d-flex gap-1 card-action-buttons">
                  <!-- زر واحد يتغير حسب حالة الكارت -->
                    <button *ngIf="!card.isActive"
                      class="btn btn-sm btn-outline-success icon-action-btn"
                          (click)="activate(card)"
                          [title]="curentLang === 'en' ? 'Activate' : (curentLang === 'ar' ? 'تفعيل' : 'הפעל')">
                    <i class="fa fa-toggle-on"></i>
                  </button>
                  <button *ngIf="card.isActive"
                      class="btn btn-sm btn-outline-warning icon-action-btn"
                          (click)="deactivate(card)"
                          [title]="curentLang === 'en' ? 'Deactivate' : (curentLang === 'ar' ? 'تعطيل' : 'בטל')">
                    <i class="fa fa-toggle-off"></i>
                  </button>
                    <button class="btn btn-sm btn-outline-danger icon-action-btn" (click)="delete(card)"
                          [title]="curentLang === 'en' ? 'Delete' : (curentLang === 'ar' ? 'حذف' : 'מחק')">
                    <i class="fa fa-trash"></i>
                  </button>
                </div>
              </div>

              <!-- Added date -->
              <div class="text-muted small text-center mt-1">
                <i class="fa fa-calendar me-1"></i>{{ card.createdAt | date:'mediumDate' }}
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- ─── قسم المعاملات ─── -->
  <div class="row">
    <div class="col-12">
      <div class="card shadow-sm section-card">
        <div class="card-header section-card__header">
          <h5 class="mb-1 section-title">
            <i class="fa fa-history me-2"></i>
            {{ curentLang === 'en' ? 'Transactions' : (curentLang === 'ar' ? 'معاملات التاجر' : 'עסקאות') }}
          </h5>
          <p class="section-subtitle mb-0">
            {{ curentLang === 'en' ? 'Review payment history and current transaction states.' : (curentLang === 'ar' ? 'مراجعة سجل الدفعات وحالات المعاملات الحالية.' : 'סקירת היסטוריית תשלומים ומצבי עסקאות.') }}
          </p>
        </div>
        <div class="card-body p-0 section-card__body">

          <!-- Loading -->
          <div *ngIf="loadingTx" class="text-center py-4">
            <span class="spinner-border spinner-border-sm" role="status"></span>
          </div>

          <!-- Empty -->
          <div *ngIf="!loadingTx && !transactions.length" class="alert alert-light border text-center m-3 empty-state">
            <i class="fa fa-inbox fa-2x mb-2 d-block text-muted"></i>
            {{ curentLang === 'en' ? 'No transactions yet.' : (curentLang === 'ar' ? 'لا توجد معاملات بعد.' : 'אין עסקאות עדיין.') }}
          </div>

          <!-- Table -->
          <div class="table-responsive" *ngIf="!loadingTx && transactions.length">
            <table class="table table-hover align-middle mb-0 transactions-table">
              <thead class="table-dark transactions-table__head">
                <tr>
                  <th class="text-center">#</th>
                  <th>{{ curentLang === 'en' ? 'Customer' : (curentLang === 'ar' ? 'الزبون' : 'לקוח') }}</th>
                  <th>{{ curentLang === 'en' ? 'Description' : (curentLang === 'ar' ? 'الوصف' : 'תיאור') }}</th>
                  <th>{{ curentLang === 'en' ? 'Amount' : (curentLang === 'ar' ? 'المبلغ' : 'סכום') }}</th>
                  <th>{{ curentLang === 'en' ? 'Card' : (curentLang === 'ar' ? 'الكارت' : 'כרטיס') }}</th>
                  <th>{{ curentLang === 'en' ? 'Invoice' : (curentLang === 'ar' ? 'الفاتورة' : 'חשבונית') }}</th>
                  <th>{{ curentLang === 'en' ? 'Status' : (curentLang === 'ar' ? 'الحالة' : 'סטטוס') }}</th>
                  <th>{{ curentLang === 'en' ? 'Date' : (curentLang === 'ar' ? 'التاريخ' : 'תאריך') }}</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let tx of transactions">

                  <!-- # -->
                  <td class="text-center text-muted small">#{{ tx.id }}</td>

                  <!-- اسم الزبون -->
                  <td>
                    <div class="fw-medium">{{ tx.customerName || '—' }}</div>
                    <div class="text-muted small" *ngIf="tx.customerEmail">{{ tx.customerEmail }}</div>
                  </td>

                  <!-- الوصف -->
                  <td class="small">{{ tx.description || '—' }}</td>

                  <!-- المبلغ -->
                  <td class="fw-semibold">
                    {{ tx.amount }}
                    <span class="text-muted small ms-1">{{ tx.currencyCode }}</span>
                  </td>

                  <!-- الكارت -->
                  <td>
                    <span class="fw-medium">••••&nbsp;{{ tx.cardLast4 }}</span>
                    <div class="text-muted small">{{ tx.cardHolderName }}</div>
                  </td>

                  <!-- الفاتورة -->
                  <td class="text-nowrap">
                    <button
                      *ngIf="tx.issuedInvoicePdfUrl || tx.issuedInvoiceId || tx.invoiceId || tx.invoice?.id || tx.issuedInvoice?.id"
                      type="button"
                      class="btn btn-sm btn-outline-dark"
                      [disabled]="loadingInvoicePdf"
                      (click)="showInvoice(tx)"
                    >
                      <i class="fa fa-file-pdf-o me-1"></i>
                      {{ curentLang === 'en' ? 'View' : (curentLang === 'ar' ? 'عرض' : 'צפה') }}
                    </button>
                    <span *ngIf="!(tx.issuedInvoicePdfUrl || tx.issuedInvoiceId || tx.invoiceId || tx.invoice?.id || tx.issuedInvoice?.id)" class="text-muted">—</span>
                  </td>

                  <!-- الحالة -->
                  <td>
                    <span class="badge rounded-pill px-3 py-2 tx-status-badge {{ txStatusBadge(tx.status) }}">
                      {{ tx.status }}
                    </span>
                  </td>

                  <!-- التاريخ -->
                  <td class="small text-nowrap tx-date">{{ formatDate(tx.createdAt) }}</td>

                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>

  </ng-container>

</div>

<div class="invoice-modal-overlay" *ngIf="showInvoicePanel" (click)="closeInvoicePanel()">
  <div class="invoice-modal-box" (click)="$event.stopPropagation()">
    <div class="invoice-modal-box__header">
      <h5 class="mb-0">
        <i class="fa fa-file-pdf-o me-2"></i>
        {{ curentLang === 'en' ? 'Invoice Preview' : (curentLang === 'ar' ? 'معاينة الفاتورة' : 'תצוגת חשבונית') }}
      </h5>
      <div class="invoice-modal-actions">
        <button type="button" class="invoice-open-tab-btn" (click)="openInvoiceInNewTab()">
          <i class="fa fa-external-link me-1"></i>
          {{ curentLang === 'en' ? 'Open in new tab' : (curentLang === 'ar' ? 'فتح في نافذة جديدة' : 'פתח בלשונית חדשה') }}
        </button>
        <button type="button" class="invoice-modal-close" (click)="closeInvoicePanel()" aria-label="Close">
          ×
        </button>
      </div>
    </div>
    <div class="invoice-modal-box__body">
      <iframe
        *ngIf="invoicePdfUrl"
        [src]="invoicePdfUrl"
        class="invoice-modal-iframe"
        frameborder="0"
      ></iframe>
    </div>
  </div>
</div>

<ng-template #notMerchant>
  <div class="container-fluid">
    <div class="alert alert-warning">
      {{ curentLang === 'en' ? 'This page is for merchants only.' : (curentLang === 'ar' ? 'هذه الصفحة متاحة للتجار فقط.' : 'עמוד זה זמין לסוחרים בלבד.') }}
    </div>
  </div>
</ng-template>
